<!--  -->
<template>
  <div class="m_partner">
    <mb-header></mb-header>

    <swiper class="swiper-container-three" id="home2" :options="swiperOption">
      <!-- slides -->
      <swiper-slide class="swiper-item" v-for="(item,index) of imgList2" :key="index">
        <!-- <swiper-slide class="swiper-item"> -->
        <img class="swiper-img" :src="item" alt>
      </swiper-slide>
    </swiper>
    <div class="body">
      <div class="vict">
        <span :class="{active: curTab === 1}" @click="onChangeTab(1)">川口工厂</span>
        <span :class="{active: curTab === 2}" @click="onChangeTab(2)">野田工厂</span>
        <span :class="{active: curTab === 3}" @click="onChangeTab(3)">野田第二工厂</span>
      </div>
      <div class="right">
        <img src="../assets/pars1.png" alt class="partner_logo">
        <ul>
          <li v-for="(item, index) in partnerData" :key="index">
            <div v-show="curTab === item.id">
              <h3 class="name">{{item.title_name}}</h3>
              <p class="right_info">{{item.info}}</p>
              <img :src="item.img" alt class="right_img">
              <div class="right_list">
                <h3>主要设备：</h3>
                <p v-for="(data, i) in item.arr" :key="i" class="right_list_item">{{data}},</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <mb-fotter></mb-fotter>
    <back-top></back-top>
  </div>
</template>

<script>
import mbFotter from "../components/moblie-fotter.vue";
import mbHeader from "../components/moblie-header.vue";
import backTop from "../components/back-top.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    mbFotter,
    mbHeader,
    backTop
  },

  data() {
    //这里存放数据
    return {
      curTab: 1,
      swiperOption: {
        autoplay: true,
        speed: 1800,
        delay: 2000,
        loop: true,
        effect: "fade",
        obvserver: true,
        obvserverParents: true,
        fadeEffect: {
          crossFade: true
        }
      },
      imgList2: [
        require("../assets/m/H6BAN1.jpg"),
        require("../assets/m/H6BAN2.jpg"),
        require("../assets/m/H6BAN3.jpg")
      ],
      partnerData: [
        {
          id: 1,
          title_name: "川口工厂",
          info:
            "川口工厂主要从事定制齿轮和追加工齿轮的制造。KHK齿轮的设计和开发也全部在这里进行。",
          img: require("../assets/pars2.png"),
          arr: [
            "复核加工机(Mazak)",
            "立式加工中心(Mazak)",
            "立式加工中心(KIRA)",
            "数控齿轮加工机床(Kashifuji)",
            "数控齿轮磨床(Gleason)",
            "线切割放电加工机(FANUC)",
            "数控三维测量仪(Mitsutoyo)"
          ]
        },
        {
          id: 2,
          title_name: "野田工厂",
          info:
            "几乎所有的KHK库存标准齿轮都在野田工厂生产。齿条和锥齿轮的定做品也包括在内。在部分工序中，通过工业自动化以节省人力正在逐步推进。",
          img: require("../assets/pars3.png"),
          arr: [
            "数控车床(Muratec)，数控齿条切齿机(Saikuni)",
            "蜗杆磨床(Drake)，数控插齿机(Mitsubishi)",
            "数控车床(Tsugami)，数控锥齿轮切齿机(Gleason)",
            "数控磨齿机(Gleason)，立式加工中心(Mazak)",
            "数控弧齿锥齿轮磨齿机(格里森)",
            "数控三坐标测量仪(ZEISS)"
          ]
        },
        {
          id: 3,
          title_name: "野田第二工厂",
          info:
            "高频淬火热处理后的硬度测试，喷丸处理，蜗轮切齿加工等等在第二工厂进行。",
          img: require("../assets/pars4.png"),
          arr: ["激光淬火装置(Laserline)", "高频淬火炉(NETUREN)"]
        }
      ]
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {},

  //方法集合
  methods: {
    onChangeTab(tab) {
      this.curTab = tab;
    }
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<style lang='less' scoped>
.m_partner {
  background: #ecfcff;
  min-height: 100vh;
  .swiper-container-three {
    .swiper-item {
      img {
        width: 100%;
        // height: 100%;
        vertical-align: top;
        object-fit: cover;
      }
    }
  }
  .body {
    display: flex;
    .vict {
      display: flex;
      flex-direction: column;
      margin-left: 2%;
      width: 26%;
      margin-right: 2%;
      span {
        display: inline-block;
        cursor: pointer;
        border: 1px solid #0583c9;
        width: 100%;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        margin-top: 0.38rem;
        color: #0583c9;
        border-radius: 5px;
        font-weight: 600;
        font-size: 0.24rem;
        &.active {
          color: #fff;
          background: #0583c9;
        }
      }
    }
    .right {
      width: 74%;
      margin-right: 2%;
      .partner_logo {
        width: 100%;
        margin-top: 0.38rem;
      }
      ul {
        width: 100%;
        li {
          p.right_info {
            line-height: 1.5;
            color: #0583c9;
          }
          .right_list {
            h3 {
              font-weight: 600;
              color: #0583c9;
            }
            .right_list_item {
              margin-left: 4%;
              color: #0583c9;
            }
          }
          .right_img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>